import { render, staticRenderFns } from "./PreConsultationHelper.vue?vue&type=template&id=62a953b0&scoped=true"
import script from "./PreConsultationHelper.vue?vue&type=script&lang=js"
export * from "./PreConsultationHelper.vue?vue&type=script&lang=js"
import style0 from "./PreConsultationHelper.vue?vue&type=style&index=0&id=62a953b0&prod&lang=less&scoped=true"
import style1 from "./PreConsultationHelper.vue?vue&type=style&index=1&id=62a953b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a953b0",
  null
  
)

export default component.exports